import * as Sentry from '@sentry/react';

import sentryOptions from './sentry-options';

if (process.env.REACT_APP_ENV_SENTRY) {
  Sentry.init(sentryOptions);
}
